<div class="b2c-dashboard">
    <div class="row">
        <div class="col-xs-12">
            <div class="card card--box card--box--dashboard">
                <div class="card-block card--box--dashboard__block hidden">
                    <div class="mx-auto card--box--dashboard__block__header">
                        <h2>
                            {{ 'Welcome to B2C Admin' | translate }}
                        </h2>
                    </div>
                </div>

                <b2c-admin-filters-search [isHome]="true"
                                          [hasClinic]="true"
                                          [hasDate]="true"
                                          [hasTestData]="true"
                                          (setFilterParams)="setFilterParams($event)"
                                          (searchData)="getItems()"></b2c-admin-filters-search>

            </div>
        </div>
    </div>

    <div class="row mr-t--md">
        <div class="col-xs-12">
            <metrics-component [isHome]="true" [filters]="filters"></metrics-component>
        </div>
    </div>

    <div class="row mr-t--md mr-b--md">
        <div class="col-xs-12">
            <dynamic-report-component [isHome]="true" [filters]="filters" [filterParams]="filterParams"></dynamic-report-component>
        </div>
    </div>

    <div class="row mr-t--md">
        <div class="col-xs-12">
            <nps-component [isHome]="true" [filters]="filters"></nps-component>
        </div>
    </div>

    <div class="row mr-t--md">
        <div class="col-xs-12">
            <coupons-component [isHome]="true" [filters]="filters"></coupons-component>
        </div>
    </div>

    <div class="row mr-t--md">
        <div class="col-xs-12">
            <vouchers-component [isHome]="true" [filters]="filters"></vouchers-component>
        </div>
    </div>

    <div class="row mr-t--md mr-b--md">
        <div class="col-xs-12">
            <impersonate-component [isHome]="true" [filters]="filters"></impersonate-component>
        </div>
    </div>

    <div class="row mr-t--md mr-b--md">
        <div class="col-xs-12">
            <events-component [isHome]="true" [filters]="filters"></events-component>
        </div>
    </div>

    <div class="row mr-t--md mr-b--md">
        <div class="col-xs-12">
            <platform-registration-counts-component [isHome]="true" [filters]="filters"></platform-registration-counts-component>
        </div>
    </div>

    <div class="row mr-t--md mr-b--md">
        <div class="col-xs-12">
            <appointments-component [isHome]="true" [filters]="filters"></appointments-component>
        </div>
    </div>

    <div class="row mr-t--md mr-b--md">
        <div class="col-xs-12">
            <suicidality-component [isHome]="true" [filters]="filters"></suicidality-component>
        </div>
    </div>

    <div class="row mr-t--md mr-b--md">
        <div class="col-xs-12">
            <package-billing-component [isHome]="true" [filters]="filters" [filterParams]="filterParams"></package-billing-component>
        </div>
    </div>

    <div class="row mr-t--md mr-b--md">
        <div class="col-xs-12">
            <jwt-token-component></jwt-token-component>
        </div>
    </div>

</div>
